<template>

  <ob-dialog :heading="$tc('asset-attributes.entity-name', 1)" @ok="ok()" @cancel="close()">
    <v-text-field v-model="values.name" :label="$t('name')" data-test="asset-attribute-name"></v-text-field>
    <v-text-field v-model="values.ord" :label="$t('order')" type="number" step="1" min="1" data-test="asset-attribute-order"></v-text-field>
  </ob-dialog>

</template>

<script>
  import ObDialog from '../../../shared/components/dialog'

  export default {
    name: 'asset-attribute-dialog',

    props: [ 'attribute' ],

    data () {
      return {
        values: {}
      }
    },

    methods: {
      ok () {
        this.$emit('submit', Object.assign(this.attribute || {}, this.values))
      },

      close () {
        this.$emit('submit', false)
      },
    },

    mounted () {
      this.values = Object.assign({ ord: 1 }, this.attribute)
    },

    components: {
      ObDialog
    }
  }
</script>

<style scoped lang="scss">

</style>
